export enum ExpiredCardRouteName {
    Index = 'finance.expired-cards.index',
    Notify = 'finance.expired-cards.notify',
}

export default {
    path: 'expired-cards',
    name: ExpiredCardRouteName.Index,
    component: () => import('@/views/finance/expired-cards/Index.vue'),
    meta: {
        label: 'Expired Cards',
        auth: true,
        permission: 'manage-payments',
        icon: 'fal fa-file-invoice-dollar fa-fw',
        location: 'sidebar',
        parent: 'finance',
    },
    children: [
        {
            path: ':cardId/notify',
            name: ExpiredCardRouteName.Notify,
            component: () => import('@/views/finance/expired-cards/Index.vue'),
            meta: {
                label: 'Notify',
                auth: true,
                permission: 'manage-payments',
                parent: ExpiredCardRouteName.Index,
            },
        },
    ],
}
